<page-headline
    [linkTitle]="''"
    [module]="pageHeadline.module"
    [moduleIcon]="pageHeadline.moduleIcon"
    [moduleLink]="pageHeadline.moduleLink"
    [pageTitle]="pageHeadline.pageTitle"
    [linkArray]="pageHeadline.linkArray"
>
    <!-- <page-headline
    [linkTitle]="'Historical Trends Home'"
    [module]="'historical-trends'"
    [moduleIcon]="'fa-chart-line'"
    [moduleLink]="'historical-trends'"
    [pageTitle]="pageTitle"
> -->
</page-headline>
<div>
    <div>
        <main-filters (filtersOutput)="applyNewFilters($event)"></main-filters>
        <div class="row-layout-track-left-align layout-padding-bottom__1rem">
            <display-options (displayOptionsOutput)="applyDisplayOptions($event)">
            </display-options>
            <action-panel
                [showExportCsv]="false"
                [showSaveAsPdf]="true"
                [showPrint]="false"
                [title]="pageHeadline.pageTitle"
            >
            </action-panel>
        </div>
        <!-- <div class="stream-graph-area">
            <large-card [largeCardInteriorOptions]="largeCardInteriorOptions"></large-card>
        </div> -->
        <!-- <div class="row-layout-track">
            
        </div> -->
        <div *ngFor="let cardId of largeCardIdArray" class="largecard-layout-box__100">
            <ng-template customDashboardsOutlet [item]="cardId"></ng-template>
        </div>
    </div>
</div>
